module.exports = __webpack_public_path__ + "static/media/Cats eyes 08_SVENSKA-mixdown.8cca4a80.mp3";